import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';  
import { BehaviorSubject, map, Observable, tap } from 'rxjs';
import { Api, ApiAuth } from 'app/domain/api';
import { ApiResponse } from 'app/domain/auth.model';
import { SupplierDTO } from 'app/domain/api.model';


@Injectable({providedIn: 'root'})
export class SupplierService  { 

  constructor(private http: HttpClient) { }


  
  private _suppliers: BehaviorSubject<SupplierDTO[] | null> = new BehaviorSubject<SupplierDTO[] | null>(null);
  
  get suppliers$(): Observable<SupplierDTO[] | null> {
    return this._suppliers.asObservable();
  }

  

  getAll(): Observable<SupplierDTO[]> {
    return this.http.get<SupplierDTO[]>(Api.Suppliers).pipe(
      map(suppliers => 
        // Sort logic: (a, b) comparison
        suppliers.sort((a, b) => {
  const snA = a?.surname ?? '';
  const snB = b?.surname ?? '';
  return snA.localeCompare(snB);
})
      ),
      tap((sortedCategories) => {
        this._suppliers.next(sortedCategories);
      })
    );
  }




  private _supplier: BehaviorSubject<SupplierDTO | null> = new BehaviorSubject<SupplierDTO | null>(null);
  
  get supplier$(): Observable<SupplierDTO | null> {
    return this._supplier.asObservable();
  }

  get(code : string): Observable<SupplierDTO> {
    return this.http.get<SupplierDTO>(Api.Supplier + '/get/' + code).pipe(
        tap((supplier) => {
            this._supplier.next(supplier);
        })
    );
  } 

 

  public delete(code : String) : Observable<ApiResponse> {
    return this.http.delete<ApiResponse>(Api.Supplier + "/" + code);
  }


  public load() : Observable<SupplierDTO[]> {
    return this.http.get<SupplierDTO[]>(Api.Supplier);
  }



  public save(dto : SupplierDTO) : Observable<ApiResponse> {
    if(!dto.code)
      return this.http.post<ApiResponse>(Api.Supplier, dto);
    else
      return this.http.put<ApiResponse>(Api.Supplier, dto);
  }





  private _supplierLogged: BehaviorSubject<SupplierDTO | null> = new BehaviorSubject<SupplierDTO | null>(null);
  
  get supplierLogged$(): Observable<SupplierDTO | null> {
    return this._supplierLogged.asObservable();
  }

  getLogged(): Observable<SupplierDTO> {
    return this.http.get<SupplierDTO>(Api.Supplier + '/current').pipe(
        tap((supplierLogged) => {
            this._supplierLogged.next(supplierLogged);
        })
    );
  } 
 
}
